export enum SortFieldsDeal {
  id = 'Id',
  businessName = 'BusinessName',
  advanced = 'Advanced',
  payback = 'Payback',
  paymentFrequency = 'PaymentFrequency',
  paymentAmount = 'PaymentAmount',
  term = 'Term',
  net = 'Net',
  collected = 'Collected',
  paidOff = 'PaidOff',
  remaining = 'Remaining',
  rep = 'Rep',
  funder = 'Funder',
  label = 'Label',
  inhouseCompany = 'InhouseCompany',
  pnl = 'Pnl',
  status = 'Status',
  paidStatus = 'PaidStatus',
  funded = 'Funded'
}

export enum DealsStatus {
  new = 'New',
  declined = 'Declined',
  approved = 'Approved',
  outhouseApproved = 'OuthouseFunded',
  inUnderwriting = 'InUnderwriting',
  readyToFund = 'ReadyToFund',
  pending = 'Pending',
}

export enum DealsType {
  inhouse = 'InHouse',
  outhouse = 'OutHouse',
}

export enum ExtendDealType {
  flex = 'Flex',
  reverse = 'Reverse',
}

export enum FlexReceivablesType {
  full = 'Full',
  partial = 'Partial',
}

export enum RepPortfolioSummarySortFields {
  company = 'Company',
  dealId = 'DealId',
  startDate = 'StartDate',
  iso = 'Iso',
  status = 'Status',
  factor = 'Factor',
  frequentPayment = 'FrequentPayment',
  advanceAmount = 'AdvanceAmount',
  isoFee = 'IsoFee',
  payback = 'Payback',
  totalCommission = 'TotalCommission',
  psf = 'Psf',
}

export enum RejectedStatus {
  rejected = "Rejected",
  resolved = "Resolved"
}